import { render, staticRenderFns } from "./PriceMonitor.vue?vue&type=template&id=5ddcef3b"
import script from "./PriceMonitor.vue?vue&type=script&lang=ts"
export * from "./PriceMonitor.vue?vue&type=script&lang=ts"
import style0 from "./PriceMonitor.vue?vue&type=style&index=0&id=5ddcef3b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QInput,QSelect,QItem,QItemSection,QCard,QCardSection,QPagination,QBtn});
